import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeleteIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14 18",
	style: { enableBackground: "new 0 0 14 18" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_7433",
		d: "M1,16c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H3C1.9,4,1,4.9,1,6V16z M13,1h-2.5 L9.8,0.3C9.6,0.1,9.4,0,9.1,0H4.9C4.6,0,4.4,0.1,4.2,0.3L3.5,1H1C0.4,1,0,1.4,0,2s0.4,1,1,1h12c0.6,0,1-0.4,1-1S13.6,1,13,1z"
	})
});
export { SvgDeleteIcon as ReactComponent };
